import PropTypes from 'prop-types';
import React, { useState } from 'react';

import * as S from './SearchBox.styles';

export const SearchBox = ({ delay, placeholder, autoFocus, refine }) => {
  const [value, setValue] = useState();
  const [timerId, setTimerId] = useState(null);

  const onChangeDebounced = e => {
    const newValue = e.target.value;

    clearTimeout(timerId);
    const newTimerId = setTimeout(() => refine(newValue), delay);

    setTimerId(newTimerId);
    setValue(newValue);
  };

  return (
    <S.StyledInput
      value={value}
      onChange={onChangeDebounced}
      placeholder={placeholder}
      autoFocus={autoFocus}
    />
  );
};

SearchBox.propTypes = {
  delay: PropTypes.number,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  refine: PropTypes.func,
};
